var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"list-header"},[_c('h1',{staticClass:"color-primary page-title"},[_vm._v(_vm._s(_vm.title))]),_c('b-button',{attrs:{"variant":"primary"},on:{"click":_vm.onClick}},[_vm._v(_vm._s(_vm.buttonActionText))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }